import { useRef, useState } from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import LOGOIMAGE from "../../../../assets/MKTGFLO-Logo-RGB-Positive.png";
import {
  CenterWrapper,
  LeftPaneWrapper,
  LOGIN_COLOR,
  LOGIN_FONT_SIZE,
  LogoImgWrapper,
  LogoWrapper,
  TextFieldTitleWrapper,
} from "../login/login.styles";
import { IError } from "../../../../redux/actions/errorHandlingAction";
import { Nullable } from "../../../../types/common";
import { LoginPaneProps } from "./login-pane.props";
import { ICredentialErrors } from "../../../../features/user/types/icredential-errors.interface";
import { BRANDING } from "../../../../features/navigation/types/pages.constant";

const LoginPane = ({
  userData,
  errors,
  loading,
  rememberMe,
  handleChange,
  handleRemeberMe,
  handleForgotPassword,
  handleSubmit,
}: LoginPaneProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const passwordInputRef = useRef<Nullable<HTMLInputElement>>(null);

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      if (event.target.id === "email") {
        passwordInputRef.current?.focus();
      } else if (event.target.id === "password") {
        handleSubmit(event);
      }
    }
  };

  return (
    <LeftPaneWrapper>
      <LogoWrapper>
        <LogoImgWrapper src={LOGOIMAGE} alt={BRANDING.APPLICATION.TITLE} />
      </LogoWrapper>
      <CenterWrapper>
        <TextFieldTitleWrapper>Email</TextFieldTitleWrapper>
        <TextField
          variant="outlined"
          margin="dense"
          value={userData.email}
          fullWidth={true}
          id="email"
          label="email"
          name="email"
          type="email"
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          helperText={(errors as ICredentialErrors).emailError}
          error={!!(errors as ICredentialErrors).emailError}
        />
        <TextFieldTitleWrapper>Password</TextFieldTitleWrapper>
        <TextField
          variant="outlined"
          margin="dense"
          value={userData.password}
          fullWidth={true}
          id="password"
          name="password"
          label="password"
          type={showPassword ? "text" : "password"}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          helperText={(errors as ICredentialErrors).passwordError}
          error={!!(errors as ICredentialErrors).passwordError}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          inputRef={passwordInputRef}
        />
        {(errors as IError).errorMessage && (
          <Typography variant="body2" color="error">
            {(errors as IError).errorMessage}
          </Typography>
        )}
        <Grid container={true} direction="row" justify="space-between" alignItems="center">
          <Grid item={true}>
            <Checkbox
              checked={rememberMe}
              onChange={handleRemeberMe}
              name="rememberMe"
              color="default"
              style={{ paddingLeft: "0px" }}
            />
            Remember Me
          </Grid>
          <Button
            style={{ fontSize: LOGIN_FONT_SIZE, color: LOGIN_COLOR }}
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </Button>
        </Grid>
        <Button
          style={{
            fontSize: "15px",
            marginTop: "30px",
            width: "130px",
            backgroundColor: LOGIN_COLOR,
            color: "white",
          }}
          size="large"
          type="submit"
          variant="contained"
          disabled={loading}
          onClick={handleSubmit}
        >
          Sign In
          {loading && <CircularProgress size={30} color="secondary" />}
        </Button>
      </CenterWrapper>
    </LeftPaneWrapper>
  );
};

export default LoginPane;
